// extracted by mini-css-extract-plugin
export default {"review-user":"ReviewUser_review-user__NJUT7","user-pp":"ReviewUser_user-pp__G6cGF"};